import useUsers from 'src/admin/users/hooks/useUsers';

export const useAdvisors = () => {
  const { users, isLoading, refetch } = useUsers(['ADVISOR', 'SYSTEM_ADMIN', 'SERVICE_ADMIN']);

  return {
    advisors: users,
    isLoading,
    refetch,
  }
};
